module.exports = __webpack_public_path__ + "img/no-ticket.a88fc6ff.png";